import React from 'react';
import PropTypes from 'prop-types';
import Calendar from './assets/calendar.svg';
import CircleCheck from './assets/check-circle.svg';
import Clock from './assets/clock.svg';
import Phone from './assets/phone.svg';
import Trash from './assets/trash.svg';
import Warning from './assets/warning-exclamation.svg';

const iconsMap = {
  calendar: Calendar,
  circleCheck: CircleCheck,
  clock: Clock,
  phone: Phone,
  trash: Trash,
  warning: Warning,
};

function Icon({ iconName, style, onClick }) {
  const IconComponent = iconsMap[iconName];

  return (
    <IconComponent
      onClick={onClick}
      style={{
        verticalAlign: '-0.125em', display: 'inline-block', lineHeight: '1em', height: '1em', ...style,
      }}
    />
  );
}

Icon.propTypes = {
  iconName: PropTypes.oneOf(['calendar', 'circleCheck', 'clock', 'phone', 'trash', 'warning']).isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default Icon;
